import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as styles from "./InfoCard.module.css";
import clsx from "clsx";
export const InfoCard = _ref => {
  let {
    title,
    content,
    layoutClassName
  } = _ref;
  return _jsxs("div", {
    className: clsx([layoutClassName && layoutClassName], styles.container),
    children: [_jsx("span", {
      className: styles.title,
      children: title
    }), _jsx("div", {
      className: styles.content,
      children: content
    })]
  });
};